/**
 * Formats a duration in seconds into a human-readable time string (HH:MM:SS or MM:SS)
 * @param totalSeconds - The duration in seconds
 * @returns A formatted string in the format HH:MM:SS for durations >= 1 hour, or MM:SS for shorter durations
 */
export const formatDuration = (totalSeconds?: number | null): string => {
  if (!totalSeconds || totalSeconds < 0) return "--:--";
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);
  const two = (n: number) => String(n).padStart(2, "0");
  return hours > 0 ? `${two(hours)}:${two(minutes)}:${two(seconds)}` : `${two(minutes)}:${two(seconds)}`;
};
